import { useQueryClient } from 'react-query';
import { handleErrorToast, handleSuccessToast } from 'src/components/molecules';
import {
  useReassignReportAssigneeMutation,
  useUpdateDeterminedCategoryMutation,
  useUpdateSubmissionDateMutation,
  useUpdateSubstantiationStatusMutation,
} from 'src/graphql';

export const useUpdateReportDetails = () => {
  const queryClient = useQueryClient();
  const { mutate: mutationUpdateDeterminedCategory } =
    useUpdateDeterminedCategoryMutation({
      onSuccess: () => {
        queryClient.invalidateQueries(['CaseById']);
        handleSuccessToast({
          toastMessage: 'Determined category updated successfully',
        });
      },
      onError: () => {
        handleErrorToast({
          toastMessage: 'Error updating determined category',
        });
      },
    });

  const { mutate: mutationReassignReportAssignee } =
    useReassignReportAssigneeMutation({
      onSuccess: () => {
        queryClient.invalidateQueries(['CaseById']);
        handleSuccessToast({
          toastMessage: 'Reported to updated successfully',
        });
      },
      onError: () => {
        handleErrorToast({
          toastMessage: 'Error updating report to',
        });
      },
    });

  const { mutate: mutationUpdateSubstantiationStatus } =
    useUpdateSubstantiationStatusMutation({
      onSuccess: () => {
        queryClient.invalidateQueries(['CaseById']);
        handleSuccessToast({
          toastMessage: 'Substantiation status updated successfully',
        });
      },
      onError: () => {
        handleErrorToast({
          toastMessage: 'Error updating substantiation status',
        });
      },
    });

  const { mutate: mutationUpdateSubmissionDate } =
    useUpdateSubmissionDateMutation({
      onSuccess: () => {
        queryClient.invalidateQueries(['CaseById']);
        handleSuccessToast({
          toastMessage: 'Submission date updated successfully',
        });
      },
      onError: () => {
        handleErrorToast({
          toastMessage: 'Error updating submission date',
        });
      },
    });

  return {
    mutationReassignReportAssignee,
    mutationUpdateDeterminedCategory,
    mutationUpdateSubmissionDate,
    mutationUpdateSubstantiationStatus,
  };
};
